import React from 'react';
import PropTypes from 'prop-types';

import LogoPartenaireComponent from './LogoPartenaireComponent';

import { getMerchantCardUrl } from '../../services/partner/utils';

import './PartnerBlockHorizontalComponent.scss';

class PartnerBlockHorizontalComponent extends React.Component {
    renderConditionnalTitle(partner) {
        return partner && partner.name ? partner.name : '';
    }

    extractOrBlank(str) {
        return str ? ` ${str}` : '';
    }

    render() {
        const { partner, cssClass, noLogoLink, children } = this.props;
        const urlFicheMarchand = !noLogoLink ? getMerchantCardUrl(partner) : '';

        return (
            <div className={`partner-row grid ${this.extractOrBlank(cssClass)}`}>
                <div className="partner-row-logo flex-container-h flex-center-alt">
                    <LogoPartenaireComponent
                        partenaire={partner}
                        url={urlFicheMarchand}
                        title={this.renderConditionnalTitle(partner)}
                    />
                </div>
                {children}
            </div>
        );
    }
}

PartnerBlockHorizontalComponent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    cssClass: PropTypes.string,
    partner: PropTypes.object.isRequired,
    noLogoLink: PropTypes.bool.isRequired
};

export default PartnerBlockHorizontalComponent;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerBlockHorizontalComponent.js